import Button from 'components/button/button';
import { CheckListIcon } from 'icons/check-list';
import s from './customization-task-card-button.module.scss';

type Props = {
  count?: number;
};

const CustomizationTaskCardButton = ({ count = 1 }: Props) => {
  return (
    <Button className={s.button} color="inherit" variant="contained" size="S">
      <div className={s.content}>
        <CheckListIcon /> <span>{count}</span>
      </div>
    </Button>
  );
};

export default CustomizationTaskCardButton;
